import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MessageList from '../MessageList';
import MessageDetail from '../MessageDetail';
import './SmartInbox.css';

const SmartInbox = () => {
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    type: 'all',
    status: 'unread',
    priority: 'all'
  });

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/api/messages', { params: filters });
        setMessages(response.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch messages');
        console.error('Error fetching messages:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [filters]);

  return (
    <div className="smart-inbox">
      <div className="inbox-filters">
        <div className="search-bar">
          <input type="text" placeholder="Search messages..." />
        </div>
        <div className="filter-options">
          {/* Filter controls will go here */}
        </div>
      </div>
      
      <div className="inbox-content">
        {loading ? (
          <div>Loading messages...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : (
          <>
            <MessageList 
              messages={messages}
              filters={filters}
              onMessageSelect={setSelectedMessage}
            />
            {selectedMessage && (
              <MessageDetail 
                message={selectedMessage}
                onClose={() => setSelectedMessage(null)}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SmartInbox; 